import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getSession,
  getBlockId,
  getSubmissibleOnscreenVariables,
  getWarnings,
  getIsWorking,
  makeGetTextFor,
} from '../../selectors';
import { updateWarnings } from '../../actions/warnings';
import { startWorking, stopWorking } from '../../actions/ui';
import { updateSessionRequest } from '../../api';
import { loadNewState } from '../../actions';
import transformFileUploadVariables from '../../utils/file_upload_variable_transformer';

class Submit extends React.Component {
  static propTypes = {
    session: PropTypes.object.isRequired,
    blockId: PropTypes.string.isRequired,
    loadNewState: PropTypes.func.isRequired,
    submissibleOnscreenVariables: PropTypes.object.isRequired,
    updateWarnings: PropTypes.func.isRequired,
    warnings: PropTypes.object.isRequired,
    startWorking: PropTypes.func.isRequired,
    stopWorking: PropTypes.func.isRequired,
    working: PropTypes.bool.isRequired,
    getTextFor: PropTypes.func.isRequired,
  }

  componentDidMount() {
    document.addEventListener('systemd.submit', this.handleSubmitEvent);
  }

  componentWillUnmount() {
    document.removeEventListener('systemd.submit', this.handleSubmitEvent);
  }

  handleSubmitEvent = (e) => {
    e.preventDefault();
    this.handleSubmit();
  }

  handleSubmit = () => {
    const { getTextFor } = this.props;
    this.props.startWorking();

    const success = (object) => {
      this.props.stopWorking();
      this.props.loadNewState(object);
    };
    const failure = (data) => {
      if (data.errors) {
        this.props.updateWarnings(data.errors);
      } else {
        alert(data.message);
      }
      this.props.stopWorking();
    };

    const sessionId = this.props.session.get('id');
    const sessionKey = this.props.session.get('metadata').get('session_key');
    const blockId = this.props.blockId;
    const updateType = 'submission';
    const variables = this.props.submissibleOnscreenVariables.toJS();

    // File upload fields need to first be uploaded to S3 asyncronously. Thus, transformFileUploadVariables
    // does so and returns a Promise which contains the new variable values for these file upload fields.
    // If any errors were encountered, it also contains the warnings object we use to update onscreen warnings with.

    transformFileUploadVariables(variables, getTextFor).then((promiseValues) => {
      const { transformedVariables, uploadValidationsWarningObject } = promiseValues;

      if (Object.keys(uploadValidationsWarningObject).length > 0) {
        this.props.updateWarnings(uploadValidationsWarningObject);
        this.props.stopWorking();
      } else {
        updateSessionRequest(sessionId, sessionKey, updateType, transformedVariables, blockId, null, success, failure);
      }
    });
  }

  renderRequirednessWarning = () => {
    if (this.props.warnings.size > 0) {
      return (
        <div className="page-block__submit--warning animate__animated animate__fadeIn">
          {this.props.getTextFor('validations.required-warning')}
        </div>
      );
    }

    return null;
  }

  submitButtonCssClass = () => {
    if (this.props.working) {
      return 'btn-primary disabled';
    }
    return 'btn-primary';
  }

  render() {
    return (
      <div className="page-block__submit">
        {this.renderRequirednessWarning()}
        <div className="page-block__submit--button-row">
          <button className={this.submitButtonCssClass()} onClick={this.handleSubmit} disabled={this.props.working}>
            <i className="fas fa-spinner fa-spin" />
            {this.props.getTextFor('continue')}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const blockId = getBlockId(state);

  return {
    blockId,
    session: getSession(state),
    submissibleOnscreenVariables: getSubmissibleOnscreenVariables(state),
    warnings: getWarnings(state),
    working: getIsWorking(state),
    getTextFor: makeGetTextFor(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadNewState: (data) => dispatch(loadNewState(data)),
  updateWarnings: (data) => dispatch(updateWarnings(data)),
  stopWorking: (data) => dispatch(stopWorking(data)),
  startWorking: (data) => dispatch(startWorking(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Submit);
